/** World Markets sidebar — symbols fetched via /api/market-data/quotes. */
export const WORLD_MARKET_REGIONS = [
  {
    id: 'americas',
    label: 'Americas',
    symbols: ['YM', 'QQQ', 'SPY', 'ES', 'NQ'],
    /* These name the instrument actually quoted, not the index it tracks.
       They used to read DJI/NDX/SPX while the underlying quotes are the YM
       future and the QQQ/SPY ETFs — harmless when only a percentage was
       shown, but wrong now that the row prints the price: an SPY quote near
       $600 under an "SPX" label reads as a broken S&P 500 level. */
    labels: {
      YM: 'YM',
      QQQ: 'QQQ',
      SPY: 'SPY',
      ES: 'ES',
      NQ: 'NQ',
    },
  },
  {
    id: 'europe',
    label: 'Europe',
    symbols: ['FCHI', 'FTSE', 'GDAXI', 'N100', 'SSMI', 'STOXX50E'],
    labels: {
      FCHI: 'FCHI',
      FTSE: 'FTSE',
      GDAXI: 'GDAXI',
      N100: 'N100',
      SSMI: 'SSMI',
      STOXX50E: 'STOXX50E',
    },
  },
  {
    id: 'asia',
    label: 'Asia',
    symbols: ['AXJO', 'HSI', 'KS11', 'N225', 'NSEI', 'SSE'],
    labels: {
      AXJO: 'AXJO',
      HSI: 'HSI',
      KS11: 'KS11',
      N225: 'N225',
      NSEI: 'NSEI',
      SSE: '000001',
    },
  },
];

export const WORLD_MARKET_SYMBOLS = WORLD_MARKET_REGIONS.flatMap((region) => region.symbols);
